import ErrorTwoToneIcon from '@mui/icons-material/ErrorTwoTone'
import { CircularProgress } from '@mui/material'
import { useTasks } from './store'

export function SummarizedIcon({ badge = false }) {
	const { isInProgress, hasErrors } = useTasks((state) => {
		const notDoneTasks = state.tasksOrder.filter((id) =>
			['progress', 'idle'].includes(state.tasks[id].status),
		)

		const hasErrors = state.tasksOrder.some(
			(id) => state.tasks[id].status === 'error',
		)

		return {
			isInProgress: notDoneTasks.length > 0,
			hasErrors,
		}
	})

	if (isInProgress) {
		return <CircularProgress size={24} color="inherit" />
	}

	if (hasErrors) {
		return <ErrorTwoToneIcon color="error" />
	}

	return null
}
